const dropdown = {
  btns: document.querySelectorAll(".jsDropdownTrigger") as NodeListOf<HTMLElement>,
  dropdowns: document.querySelectorAll(".jsDropdown"),
  wrap: document.querySelectorAll(".jsDropdownWrap"),
  curent: 0,

  init() {
    this.setDwopdown()
    this.clickOutside()
  },

  setDwopdown() {
    this.btns.forEach((item, index) => {
      item.addEventListener("click", () => {
        if (item.dataset.open === "false") {
          this.closeAll()
          item.dataset.open = "true"
          item.classList.add("activeClass")
          this.dropdowns[index].classList.add("activeClass")
        } else {
      
          this.closeAll()
        }
      })
    })
  },
  closeAll() {
    this.btns.forEach((item, index) => {
      item.classList.remove("activeClass")
      this.dropdowns[index].classList.remove("activeClass")
      item.dataset.open = "false"
    })
  },
  clickOutside() {
    window.addEventListener("click", (e) => {
      let inside = false
      this.wrap.forEach((item, index) => {
        if (item.contains(e.target as HTMLElement) || this.dropdowns[index].contains(e.target as HTMLElement)) {
          inside = true
          return inside
        }
      })      
      if (!inside) {
        this.closeAll()
      }
    })
  },
}

export default dropdown
